import * as actionTypes from './actionTypes';

export const initBroadcastSettings = () => {
  return { type: actionTypes.INIT_BROADCAST_SETTINGS };
};

export const setBroadcastSettings = (broadcastSettingsData) => {
  return { type: actionTypes.SET_BROADCAST_SETTINGS, broadcastSettingsData };
};

export const fetchBroadcastSettingsFailed = () => {
  return { type: actionTypes.FETCH_BROADCAST_SETTINGS_FAILED };
};
